import { CommonModule } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { TabService } from '@app/services/tab.service';
import type { ChatTab, DisplayVehicle, SendMessage } from '@app/services/types';
import { ChatInputSuggestionsComponent } from '@app/chat/components/chat-input-suggestions/chat-input-suggestions.component';
import { ChatInputComponent } from '@app/chat/components/chat-input/chat-input.component';
import { ChatMessagesComponent } from '@app/chat/components/chat-messages/chat-messages.component';
import { EmptyChatComponent } from '@app/chat/components/empty-chat/empty-chat.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-chat-tab',
  standalone: true,
  imports: [CommonModule, TranslocoPipe, EmptyChatComponent, ChatMessagesComponent, ChatInputSuggestionsComponent, ChatInputComponent],
  templateUrl: './chat-tab.component.html',
})
export class ChatTabComponent {
  tab = input<ChatTab>();
  isPolling = input<boolean>();
  vehicle = input<DisplayVehicle>();

  tabService = inject(TabService);

  lastMessageIsFromUser = computed(() => {
    const lastMessage = this.tab()?.messages?.slice(-1)[0];
    return lastMessage?.sender === 'you';
  });

  isLegacyThread = computed(() => {
    const id = this.tab()?.vehicleIdentification?.id;

    return !!id?.carTypeId && !id?.kTypeIdTecDoc;
  });

  isVwLegacyThread = computed(() => {
    const messages = this.tab()?.messages ?? [];

    return messages.some((message) =>
      message.content?.some((chunk) => chunk.provider === 'volkswagen' && !!chunk.document && !chunk.document.parameters?.elasticsearchId),
    );
  });

  isDeletedThread = computed(() => !!this.tab()?.isDeleted);

  public sendChatMessage(message: SendMessage): void {
    this.tabService.submitQuestion(message);
  }
}
